var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverPlaceHolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_1505_30235)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1505_30235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9062 5.99999C20.129 6.095 20.3703 6.078 20.6024 6.11751C21.2067 6.21778 21.7917 6.4156 22.3356 6.7036C22.4189 6.71652 22.4982 6.74884 22.5674 6.79808C22.6366 6.84732 22.6939 6.91217 22.7349 6.98765C23.9791 8.07683 24.2209 9.57508 24.3657 11.1623C23.6491 10.7473 22.906 10.5322 22.1411 10.3832C20.3372 10.0332 18.5147 9.97715 16.6864 10.0757C15.5265 10.1377 14.3755 10.2757 13.2526 10.5978C12.8015 10.7227 12.3679 10.9062 11.9621 11.1438C12.1084 9.55958 12.378 8.07533 13.6198 6.99315C13.7932 6.76817 14.0374 6.61192 14.3106 6.55108C14.961 6.27274 15.65 6.10127 16.3524 6.04299C16.369 6.04299 16.3836 6.01349 16.4012 5.99799H16.5475C16.5777 6.03149 16.6182 6.02149 16.6557 6.02349H16.8298C16.8673 6.02349 16.9073 6.03149 16.9375 5.99799H19.5702C19.5971 6.02899 19.6336 6.02249 19.6678 6.02349C19.7019 6.02449 19.7385 6.02849 19.7653 5.99799L19.9062 5.99999Z",
    fill: "url(#paint1_linear_1505_30235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1876 30C16.5665 29.976 14.9469 29.8235 13.3575 29.4054C13.2458 29.3759 13.1722 29.3389 13.1347 29.2159C12.5145 27.1796 12.6374 25.1582 13.2887 23.1649C13.5861 22.2542 14.219 21.5556 14.8523 20.871C14.929 20.7967 15.0013 20.7177 15.0688 20.6345C15.1521 20.5189 15.2316 20.525 15.3549 20.579C17.2499 21.4124 19.1466 21.4141 21.0451 20.584C21.1211 20.5505 21.1879 20.4809 21.2791 20.579C21.9968 21.3506 22.7164 22.1202 23.1113 23.1354C23.4038 23.8925 23.5257 24.6856 23.6018 25.4923C23.7178 26.729 23.6803 27.9507 23.2854 29.1429C23.2308 29.3084 23.1605 29.3804 22.9992 29.4219C21.4234 29.8225 19.8213 29.9775 18.1876 30Z",
    fill: "url(#paint2_linear_1505_30235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0513 14.2014C12.1732 14.5764 12.3394 14.9245 12.6237 15.2015C13.0917 15.6596 13.5539 15.7216 14.1 15.3686C14.7021 14.98 15.2871 14.5514 15.9775 14.3334C17.2968 13.9158 18.6244 13.8668 19.9593 14.2454C20.4917 14.3954 20.9441 14.7065 21.3849 15.036C21.7208 15.2861 22.0733 15.4991 22.495 15.5736C22.9826 15.6596 23.396 15.5271 23.7358 15.165C24.0912 14.7865 24.2838 14.3274 24.3428 13.8073C24.3472 13.7754 24.3535 13.7438 24.3618 13.7128C24.3618 13.7063 24.3726 13.7023 24.3833 13.6923C24.4735 13.7328 24.435 13.8188 24.4364 13.8818C24.4983 17.0053 22.2386 19.7703 19.2319 20.2534C15.9551 20.78 12.9352 18.7436 12.1376 15.4686C12.0689 15.1865 12.0069 14.902 12.005 14.6084C12.003 14.4704 11.9231 14.3229 12.0513 14.2014Z",
    fill: "url(#paint3_linear_1505_30235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.484 10.8333C19.7614 10.8423 21.3532 10.9478 22.9055 11.3979C23.2956 11.5109 23.6754 11.6549 24.0162 11.889C24.2887 12.0755 24.4247 12.3211 24.394 12.6686C24.355 13.1037 24.2697 13.5228 24.0635 13.9093C23.6139 14.7545 22.8597 15.015 22.0031 14.6229C21.7876 14.5251 21.5856 14.3989 21.4019 14.2474C20.2606 13.2972 18.9281 13.1212 17.5221 13.2207C16.3824 13.2966 15.2876 13.705 14.3667 14.3979C14.2877 14.4559 14.2038 14.5069 14.1229 14.5594C13.5461 14.921 13.0625 14.8665 12.592 14.3664C12.0606 13.8018 11.9182 13.0907 11.9304 12.3406C11.9343 12.1065 12.14 11.974 12.3204 11.858C12.8143 11.5374 13.3696 11.3804 13.9293 11.2509C15.3208 10.9293 16.7352 10.8313 18.484 10.8333Z",
    fill: "url(#paint4_linear_1505_30235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4843 20.3719C21.6242 20.2864 21.7447 20.2219 21.8553 20.1414C21.9333 20.0849 21.9845 20.1129 22.0474 20.1619C22.7344 20.6915 23.4389 21.1965 24.0951 21.7696C25.1755 22.7153 25.7304 23.934 25.899 25.3587C25.9688 25.9451 26.0033 26.5353 26.0024 27.126C26.0074 27.411 25.9218 27.6899 25.7586 27.9207C25.335 28.5163 24.7153 28.8053 24.0069 29.0979C24.6456 27.4606 24.4808 25.8548 24.1785 24.252C23.8567 22.5563 22.6978 21.4526 21.4843 20.3719Z",
    fill: "url(#paint5_linear_1505_30235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3965 29.0954C11.7744 28.8503 11.245 28.5918 10.8232 28.1487C10.6838 28.0089 10.5741 27.8408 10.5013 27.6552C10.4284 27.4696 10.394 27.2705 10.4 27.0705C10.4191 25.9609 10.4902 24.8617 10.8769 23.808C11.2415 22.8148 11.9109 22.0707 12.7076 21.4316C13.2117 21.027 13.7353 20.6475 14.2395 20.2419C14.3969 20.1154 14.5222 20.0919 14.6783 20.2229C14.7545 20.2777 14.8345 20.3268 14.9176 20.3699C13.7046 21.4526 12.5409 22.5608 12.223 24.2626C11.9231 25.8598 11.7559 27.4591 12.3965 29.0954Z",
    fill: "url(#paint6_linear_1505_30235)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1505_30235",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1505_30235",
    x1: 11.9621,
    y1: 5.99799,
    x2: 11.9621,
    y2: 11.1623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1505_30235",
    x1: 12.7292,
    y1: 20.5286,
    x2: 12.7292,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1505_30235",
    x1: 11.9786,
    y1: 13.6923,
    x2: 11.9786,
    y2: 20.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1505_30235",
    x1: 11.9297,
    y1: 10.8333,
    x2: 11.9297,
    y2: 14.8015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1505_30235",
    x1: 21.4843,
    y1: 20.11,
    x2: 21.4843,
    y2: 29.0979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1505_30235",
    x1: 10.3994,
    y1: 20.1352,
    x2: 10.3994,
    y2: 29.0954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1505_30235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6,
    height: 24,
    fill: "white",
    transform: "translate(10.4 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverPlaceHolder);
export default __webpack_public_path__ + "static/media/driver_place_holder.0659a4be.svg";
export { ForwardRef as ReactComponent };